import { Accordion } from '~components/Accordion/Accordion';
import { ContentBlockWrapper } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper';

import styles from './ContentBlockAccordion.module.scss';
import { ContentBlockAccordionProps } from './ContentBlockAccordion.types';

export function ContentBlockAccordion({
  items,
  ...sectionProps
}: ContentBlockAccordionProps) {
  return (
    <ContentBlockWrapper {...sectionProps} className={styles.wrapper}>
      {items.map((item) => (
        <Accordion {...item} key={item.id} />
      ))}
    </ContentBlockWrapper>
  );
}
